import { render, staticRenderFns } from "./TheModalServicio.vue?vue&type=template&id=97cee938&"
import script from "./TheModalServicio.vue?vue&type=script&lang=js&"
export * from "./TheModalServicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports